import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影频道", to: "/category/movie" },
  { label: "电视剧频道", to: "/category/tv" },
  { label: "综艺频道", to: "/category/variety" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200 mt-16">
      <div className="w-full max-w-page mx-auto px-4 md:px-6 pt-12 md:pt-14 pb-24 md:pb-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-accent-950 flex items-center justify-center text-xl">
                <i className="ri-play-circle-fill"></i>
              </span>
              <span className="text-lg font-extrabold text-foreground-950">
                99视频
              </span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-sm">
              99视频是一个面向影视爱好者的高清视频内容发现平台，汇集电影、电视剧、综艺等多样内容，帮助用户轻松搜索并发现精彩作品。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4">
              频道导航
            </h3>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4">
              联系与反馈
            </h3>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="mailto:service@99video.example.com"
                  className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  <i className="ri-mail-line"></i>
                  service@99video.example.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-wechat-line"></i>
                官方微信：video99
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-time-line"></i>
                服务时间：每日 9:00 - 22:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2024 99视频 · 本站为影视内容演示平台，页面内影像与资料均为虚构演示内容
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500">
              播放功能为前端演示，未接入真实播放接口
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}